var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8366 10.7828H14.0559C13.3153 12.8767 11.3094 14.378 8.96107 14.3607C6.11165 14.3397 3.75557 12.0602 3.64495 9.21286C3.52638 6.16071 5.97504 3.63985 9.00132 3.63985C10.385 3.63985 11.6478 4.16707 12.5997 5.03099C12.8252 5.23567 13.1684 5.23697 13.3902 5.02822L14.94 3.56966C15.1823 3.34152 15.1832 2.95627 14.9415 2.72737C13.4318 1.29709 11.4066 0.40559 9.17329 0.361979C4.40986 0.26898 0.394723 4.1745 0.361543 8.93875C0.328068 13.7388 4.20907 17.6404 9.00132 17.6404C13.6099 17.6404 17.3748 14.0319 17.6269 9.48631C17.6337 9.42932 17.6381 7.50329 17.6381 7.50329H9.8366C9.51682 7.50329 9.25762 7.76248 9.25762 8.08226V10.2038C9.25762 10.5236 9.51688 10.7828 9.8366 10.7828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3a2ec6bae97629f4815de65f9ec91c46.svg";
export { ForwardRef as ReactComponent };